var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$can('module', 'routebeheer') || _vm.$can('module', 'beheerplus'))?_c('div',[_c('BreadcrumbNetwork'),_c('NetworkInformation'),(_vm.$can('show', 'mapobject'))?_c('ObjectObstructions'):_vm._e(),(_vm.$can('index', 'action'))?_c('ActionLog'):_vm._e(),(_vm.$can('module', 'beheerplus'))?_c('Administration'):_vm._e(),_c('Statistics')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }